import Popover from 'bootstrap/js/dist/popover'

function modularHeightGallery() {
    var swiper = new Swiper(".modHeightGal", {
        slidesPerView: 1.5,
        spaceBetween: 30,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 20, // You can tweak this as needed
            },
        }
    });
}
modularHeightGallery();

function cardGallery() {
    var swiper = new Swiper(".fan-gallery", {
        loop: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            dynamicBullets: true,
        },
    });
}
cardGallery();

function latestNewsBlock() {
    var swiper = new Swiper(".latest-news-block", {
        slidesPerView: 1.5,
        spaceBetween: 16,
        freeMode: true,
        grabCursor: true,
        breakpoints: {
            768: {
                slidesPerView: 2.5,
            },
            991: {
                slidesPerView: 3,
            },
        }
    });
}
latestNewsBlock();


function initSliders() {
    // Store Slider
    var storeSlider = new Swiper(".storeSlider", {
        slidesPerView: 1.5,
        spaceBetween: 22,
        breakpoints: {
            768: {
                slidesPerView: 3.5,
                spaceBetween: 15,
            },
            991: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
        },
    });

    // Offer Slider
    var offerSlider = new Swiper(".offerSlider", {
        slidesPerView: 1.5,
        spaceBetween: 22,
        breakpoints: {
            768: {
                slidesPerView: 3.5,
                spaceBetween: 15,
            },
            991: {
                slidesPerView: 3,
                spaceBetween: 32,
            },
        },
    });
}

initSliders();

function nav() {
    jQuery(document).ready(function () {
        var toggler = jQuery('.navbar-toggler');
        var offcanvas = jQuery('.offcanvas');
        var smnav = jQuery('.smnav');
        var closeBtn = jQuery('.menu-close');

        toggler.click(function () {
            jQuery(this).toggleClass('active');

            // Add 'active' to .smnav only when opening
            if (jQuery(this).hasClass('active')) {
                smnav.addClass('active');
            }
        });

        jQuery(document).click(function (e) {
            if (
                !toggler.is(e.target) && toggler.has(e.target).length === 0 &&
                !offcanvas.is(e.target) && offcanvas.has(e.target).length === 0
            ) {
                toggler.removeClass('active');
                smnav.removeClass('active');
            }
        });

        // ✅ New: Close icon click also resets toggler and smnav
        closeBtn.click(function () {
            toggler.removeClass('active');
            smnav.removeClass('active');
        });
    });
}
nav();

document.addEventListener('DOMContentLoaded', function () {
    // Initialize all popovers
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new Popover(popoverTriggerEl, {
            content: function () {
                // Dynamically get the content from the div with the specified id
                var contentId = 'opening-times-content'; // Replace with your dynamic id if needed
                var contentElement = document.getElementById(contentId);
                return contentElement ? contentElement.innerHTML : 'No content available';
            },
            html: true // Enable HTML content
        });
    });

});

jQuery(document).ready(function () {
    function enableDragging() {
        jQuery('.image-container').each(function () {
            var $container = jQuery(this);
            var $img = $container.find('img');
            var $zoomInButton = $container.find('.zoom-in');
            var $zoomOutButton = $container.find('.zoom-out');

            var scale = 1;
            var scaleStep = 0.5;
            var zoomOutStep = 0.5;
            var maxScale = 3;
            var minScale = 1;
            var isDragging = false;
            var startX, startY, initialX, initialY;
            var originalLeft = 0;
            var originalTop = 0;

            $zoomInButton.on('click', function () {
                if (scale < maxScale) {
                    scale += scaleStep;
                    $img.css({
                        'transform': 'scale(' + scale + ')',
                        'transform-origin': 'center center'
                    });
                }
            });

            $zoomOutButton.on('click', function () {
                if (scale > minScale) {
                    scale -= zoomOutStep;
                    if (scale < minScale) scale = minScale;
                    $img.css({
                        'transform': 'scale(' + scale + ')',
                        'transform-origin': 'center center'
                    });
                    if (scale === minScale) {
                        $img.css({
                            'left': originalLeft + 'px',
                            'top': originalTop + 'px'
                        });
                    }
                }
            });

            $img.on('mousedown touchstart', function (e) {
                if (scale > minScale) {
                    isDragging = true;
                    startX = e.type === 'touchstart' ? e.originalEvent.touches[0].pageX : e.pageX;
                    startY = e.type === 'touchstart' ? e.originalEvent.touches[0].pageY : e.pageY;
                    initialX = parseFloat($img.css('left')) || 0;
                    initialY = parseFloat($img.css('top')) || 0;
                    $img.css('cursor', 'grabbing');
                    e.preventDefault();
                }
            });

            jQuery(document).on('mousemove touchmove', function (e) {
                if (isDragging) {
                    var currentX = e.type === 'touchmove' ? e.originalEvent.touches[0].pageX : e.pageX;
                    var currentY = e.type === 'touchmove' ? e.originalEvent.touches[0].pageY : e.pageY;
                    var dx = currentX - startX;
                    var dy = currentY - startY;
                    $img.css({
                        left: initialX + dx + 'px',
                        top: initialY + dy + 'px'
                    });
                    e.preventDefault();
                }
            });

            jQuery(document).on('mouseup touchend', function () {
                isDragging = false;
                $img.css('cursor', 'grab');
            });

            $img.css('cursor', 'grab');
            originalLeft = parseFloat($img.css('left')) || 0;
            originalTop = parseFloat($img.css('top')) || 0;
        });
    }

    function disableDragging() {
        jQuery('.image-container').each(function () {
            var $container = jQuery(this);
            var $img = $container.find('img');
            var $zoomInButton = $container.find('.zoom-in');
            var $zoomOutButton = $container.find('.zoom-out');

            $zoomInButton.off('click');
            $zoomOutButton.off('click');
            $img.off('mousedown touchstart');
            jQuery(document).off('mousemove touchmove');
            jQuery(document).off('mouseup touchend');
            $img.css('cursor', '');
        });
    }

    function checkScreenSize() {
        if (window.innerWidth > 992) {
            enableDragging();
        } else {
            disableDragging();
        }
    }

    jQuery(window).on('resize', checkScreenSize);
    checkScreenSize();
});